import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { Button, Empty, Space } from 'antd';
import { recoverFromAssetLoadError } from '../utils/assetRecovery';

type FrontErrorBoundaryProps = {
  children: ReactNode;
};

type FrontErrorBoundaryState = {
  error: Error | null;
};

export class FrontErrorBoundary extends Component<FrontErrorBoundaryProps, FrontErrorBoundaryState> {
  state: FrontErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): FrontErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Front v2 render failed:', error, info.componentStack);
    recoverFromAssetLoadError(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="front-v2-fatal-page">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="页面加载失败">
          <Space wrap>
            <Button type="primary" onClick={() => window.location.reload()}>重新加载</Button>
            <Button href="/front-v2/home">返回首页</Button>
          </Space>
        </Empty>
      </main>
    );
  }
}
